"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function CtaTwoSection({ heading = "Can SaaS businesses use Hong Kong offshore exemption?" }: { heading?: string } = {}) {
  return (
    <section className="w-full flex justify-center py-[30px] md:py-[60px] px-4 min-[1340px]:px-0">
      
      <div className="w-full max-w-[1200px] flex flex-col lg:flex-row items-center gap-8 lg:gap-[32px]">
        
        {/* TEXT */}
        <div className="w-full lg:flex-1 flex flex-col gap-8">
          
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium">
              Yes. SaaS companies typically qualify when customers are outside
              Hong Kong, servers are outside Hong Kong, and management decisions
              occur outside Hong Kong. This makes SaaS one of the most compatible
              structures with territorial taxation.
            </p>
          </div>

        </div>

        {/* IMAGE */}
        <div className="w-full lg:flex-1">
          <Image
            src="/tax-optimization/cta-two.webp"
            alt="CTA Image"
            width={800}
            height={600}
            className="w-full h-[240px] sm:h-[320px] lg:h-[400px] object-cover rounded-[16px]"
          />
        </div>

      </div>
    </section>
  );
}